
// TOAST
export const TOAST_INFO = 'TOAST_INFO';
export const TOAST_SUCCESS = 'TOAST_SUCCESS';
export const TOAST_ERROR = 'TOAST_ERROR';
export const TOAST_WARNING = 'TOAST_WARNING';
export const TOAST_SNACKBAR = 'TOAST_SNACKBAR';
export const TOAST_CLEAR = 'TOAST_CLEAR';

// OVERLAY
export const SHOW_OVERLAY = 'SHOW_OVERLAY';
export const HIDE_OVERLAY = 'HIDE_OVERLAY';

// LOGIN
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT = 'LOGOUT';
export const TOKEN_EXPIRED = "TOKEN_EXPIRED";

// USER SETTINGS
export const GET_USER_SETTINGS = 'GET_USER_SETTINGS';
export const REFRESH_SETTINGS = 'REFRESH_SETTINGS';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const LEFT_SIDE_MENU_TOGGLE = "LEFT_SIDE_MENU_TOGGLE";
export const GET_USER_CONFIGURATION = "GET_USER_CONFIGURATION";
export const GET_USER_FARM_CONFIGURATION = "GET_USER_FARM_CONFIGURATION";
export const GET_USER_FARM_CONFIGURATION_REQUEST = "GET_USER_FARM_CONFIGURATION_REQUEST";

// FILE UPLOAD
export const POST_FILE_UPLOADING = "POST_FILE_UPLOADING";
export const POST_FILE_UPLOAD_ON_FAILTURE = "POST_FILE_UPLOAD_ON_FAILTURE";
export const POST_FILE_UPLOAD_ON_SUCCESS = "POST_FILE_UPLOAD_ON_SUCCESS";
export const CLEAR_POST_FILE_UPLOAD = "CLEAR_POST_FILE_UPLOAD";

// FARM
export const GET_USER_FARM_LIST_REQUEST = "GET_USER_FARM_LIST_REQUEST";
export const GET_USER_FARM_LIST = 'GET_USER_FARM_LIST';
export const GET_FARM_LIST_REQUEST = "GET_FARM_LIST_REQUEST";
export const GET_FARM_LIST = 'GET_FARM_LIST';
export const GET_TIMEZONE_LIST = "GET_TIMEZONE_LIST";
export const GET_FARM_ENTITY_INFO_REQUEST = "GET_FARM_ENTITY_INFO_REQUEST";
export const GET_FARM_ENTITY_INFO = "GET_FARM_ENTITY_INFO";
export const SET_CURRENT_FARM = 'SET_CURRENT_FARM';
export const SET_FARM_SWITCHED = 'SET_FARM_SWITCHED';
export const FARM_NOTIFICATION_REQUEST = 'FARM_NOTIFICATION_REQUEST';
export const FARM_NOTIFICATION = 'FARM_NOTIFICATION';
export const NOTIFICATION_CONFIG_SAVING = 'NOTIFICATION_CONFIG_SAVING';
export const SET_FARM_ADDRESS = 'SET_FARM_ADDRESS';
export const SET_FARM_SETTINGS = 'SET_FARM_SETTINGS';
export const FARM_ADDRESS_SAVING = 'FARM_ADDRESS_SAVING';
export const GET_FARM_STATS_FIELD_REQUESTING = 'GET_FARM_STATS_FIELD_REQUESTING';
export const GET_FARM_STATS_FIELD = 'GET_FARM_STATS_FIELD';
export const GET_FARM_USERS_LIST = 'GET_FARM_USERS_LIST';
export const GET_FARM_USERS_LIST_REQUEST = "GET_FARM_USERS_LIST_REQUEST";
export const UPDATE_CURRENT_FARM = 'UPDATE_CURRENT_FARM';

// ORGANIZATION
export const GET_FARM_ORGANIZATION = 'GET_FARM_ORGANIZATION';
export const GET_FARM_ORGANIZATION_REQUEST = "GET_FARM_ORGANIZATION_REQUEST";
export const GET_ORGANIZATION = 'GET_ORGANIZATION';
export const GET_ORGANIZATION_REQUEST = "GET_ORGANIZATION_REQUEST";
export const GET_ORGANIZATION_CATEGORY = "GET_ORGANIZATION_CATEGORY";
export const GET_ORGANIZATION_CATEGORY_REQUEST = "GET_ORGANIZATION_CATEGORY_REQUEST";

// PERSON
export const GET_PERSON_LIST_REQUEST = 'GET_PERSON_LIST_REQUEST';
export const GET_OPERATOR_LIST_REQUEST = 'GET_OPERATOR_LIST_REQUEST';
export const GET_STATE_LIST = 'GET_STATE_LIST';
export const GET_COUNTRY_LIST = 'GET_COUNTRY_LIST';
export const GET_PERSON_LIST = 'GET_PERSON_LIST';
export const GET_OPERATOR_LIST = 'GET_OPERATOR_LIST';
export const GET_PERSON_INFO = 'GET_PERSON_INFO';
export const GET_PERSON_CONFIG = 'GET_PERSON_CONFIG';
export const CLEAR_OPERATOR_LIST = 'CLEAR_OPERATOR_LIST';

// EQUIPMENT
export const GET_EQUIPMENT_LIST_REQUEST = 'GET_EQUIPMENT_LIST_REQUEST';
export const CLEAR_EQUIPMENT_FIELDS = 'CLEAR_EQUIPMENT_FIELDS';
export const GET_EQUIPMENT_CONFIG = 'GET_EQUIPMENT_CONFIG';
export const GET_CATEGORY_TYPE_LIST = 'GET_CATEGORY_TYPE_LIST';
export const GET_SUB_CATEGORY_TYPE_LIST = 'GET_SUB_CATEGORY_TYPE_LIST';
export const GET_EQUIPMENT_FIELDS = 'GET_EQUIPMENT_FIELDS';
export const GET_EQUIPMENT_NAME_LIST = 'GET_EQUIPMENT_NAME_LIST';
export const GET_EQUIPMENT_MAKE_LIST = 'GET_EQUIPMENT_MAKE_LIST';
export const GET_EQUIPMENT_MODEL_LIST = 'GET_EQUIPMENT_MODEL_LIST';
export const GET_EQUIPMENT_VENDOR_LIST = 'GET_EQUIPMENT_VENDOR_LIST';
export const GET_EQUIPMENT_PLAN_LIST = 'GET_EQUIPMENT_PLAN_LIST';
export const GET_EQUIPMENT_LIST = 'GET_EQUIPMENT_LIST';
export const GET_EQUIPMENT_INFO = 'GET_EQUIPMENT_INFO';
export const GET_PLAN_TYPE_LIST = 'GET_PLAN_TYPE_LIST';
export const CLEAR_EQUIPMENT_LIST = 'CLEAR_EQUIPMENT_LIST';

// EQUIPMENT GROUP
export const EG_GET_PLANNED_DATE_REQUEST = 'EG_GET_PLANNED_DATE_REQUEST';
export const EG_GET_PLANNED_DATE = 'EG_GET_PLANNED_DATE';
export const GET_EQUIPMENT_GROUP_LIST_REQUEST = 'GET_EQUIPMENT_GROUP_LIST_REQUEST';
export const GET_EQUIPMENT_GROUP_LIST = 'GET_EQUIPMENT_GROUP_LIST';
export const GET_CREW_EQUIPMENT_GROUP_LIST_REQUEST = 'GET_CREW_EQUIPMENT_GROUP_LIST_REQUEST';
export const GET_CREW_EQUIPMENT_GROUP_LIST = 'GET_CREW_EQUIPMENT_GROUP_LIST';
export const SET_SELECTED_EQUIPMENT_GROUP = 'SET_SELECTED_EQUIPMENT_GROUP';
export const SET_SELECTED_EG = 'SET_SELECTED_EG';
export const EQUIPMENT_GROUP_SUCCESS = 'EQUIPMENT_GROUP_SUCCESS';
export const EQUIPMENT_GROUP_FAILURE = 'EQUIPMENT_GROUP_FAILURE';
export const EQUIPMENT_GROUP_FORM_CLEAR = 'EQUIPMENT_GROUP_FORM_CLEAR';
export const CLEAR_EQUIPMENT_GROUP_LIST = 'CLEAR_EQUIPMENT_GROUP_LIST';
export const LOAD_HISTORY = 'LOAD_HISTORY';
export const SET_AUTOMATIC_LOAD_COUNT = 'SET_AUTOMATIC_LOAD_COUNT';
export const GET_HARVESTER_LIST = 'GET_HARVESTER_LIST';
export const GET_LOAD_HISTORY_REQUEST = "GET_LOAD_HISTORY_REQUEST";
export const GET_GEO_SHAPE_LIST = "GET_GEO_SHAPE_LIST";
export const EG_GET_REGION_LIST_REQUEST = "EG_GET_REGION_LIST_REQUEST";
export const EG_GET_REGION_LIST = "EG_GET_REGION_LIST";
export const EG_GET_WORKED_ACRES_REQUEST = "EG_GET_WORKED_ACRES_REQUEST";
export const EG_GET_WORKED_ACRES = "EG_GET_WORKED_ACRES";
export const SET_BULK_LOAD = "SET_BULK_LOAD";
export const EDIT_BULK_LOAD = "EDIT_BULK_LOAD";
export const EDIT_BULK_LOADS = "EDIT_BULK_LOADS";
export const REMOVE_BULK_LOAD = "REMOVE_BULK_LOAD";
export const SET_ROUNDTRIP_DETAIL = "SET_ROUNDTRIP_DETAIL";
export const SET_ROUNDTRIP_REQUEST = "SET_ROUNDTRIP_REQUEST";
export const CLEAR_BULK_LOAD = "CLEAR_BULK_LOAD";
export const SET_DELETED_LOAD = "SET_DELETED_LOAD";
export const SET_RESTORE_LOAD = "SET_RESTORE_LOAD";
export const DELETED_LOAD_HISTORY_REQUEST = "DELETED_LOAD_HISTORY_REQUEST";
export const DELETED_LOAD_HISTORY = "DELETED_LOAD_HISTORY";
export const EG_REPORT_ISSUE = "EG_REPORT_ISSUE";
export const EG_REPORT_ISSUE_REQUEST = "EG_REPORT_ISSUE_REQUEST";
export const SET_EG_REGION_LOCATION = "SET_EG_REGION_LOCATION";
export const SET_EG_REGION_LOCATION_REQUEST = "SET_EG_REGION_LOCATION_REQUEST";
export const LOAD_HISTORY_HEADER = 'LOAD_HISTORY_HEADER';
export const SET_EG_REGION_LOCATION_LOG = "SET_EG_REGION_LOCATION_LOG";
export const SET_EG_REGION_LOCATION_LOG_REQUEST = "SET_EG_REGION_LOCATION_LOG_REQUEST";
export const GET_ALL_EQUIPMENT_GROUP_LIST_REQUEST = 'GET_ALL_EQUIPMENT_GROUP_LIST_REQUEST';
export const GET_ALL_EQUIPMENT_GROUP_LIST = 'GET_ALL_EQUIPMENT_GROUP_LIST';

// DEVICE 
export const GET_DEVICE_LIST = 'GET_DEVICE_LIST';
export const RESTART_DEVICE_APP = 'RESTART_DEVICE_APP';
export const RESTART_DEVICE_APP_SUCCESS = 'RESTART_DEVICE_APP_SUCCESS';
export const RESTART_DEVICE_APP_FAILURE = 'RESTART_DEVICE_APP_FAILURE';

// CREW
export const GET_CREW_LIST_REQUEST = 'GET_CREW_LIST_REQUEST';
export const GET_CREW_LIST = 'GET_CREW_LIST';
export const CREW_SUCCESS = 'CREW_SUCCESS';
export const CREW_FAILURE = 'CREW_FAILURE';
export const GET_SELECTED_CREW = 'GET_SELECTED_CREW';
export const CREW_CLEAR = 'CREW_CLEAR';
export const GET_WORK_PLAN_REQUEST = 'GET_WORK_PLAN_REQUEST';
export const GET_WORK_PLAN = 'GET_WORK_PLAN';
export const GET_CREW_INFO_REQUEST = "GET_CREW_INFO_REQUEST";
export const GET_CREW_INFO = "GET_CREW_INFO";
export const CLEAR_CREW_LIST = "CLEAR_CREW_LIST";
export const WHATIF_CALCULATE = "WHATIF_CALCULATE";
export const WHATIF_INFO = "WHATIF_INFO";
export const UPDATE_CREW_ACTIVE = "UPDATE_CREW_ACTIVE";

// REPORT
export const GET_PLANNED_TODATE_REQUEST = "GET_PLANNED_TODATE_REQUEST";
export const GET_PLANNED_TODATE = "GET_PLANNED_TODATE";
export const GET_SUMMARY_REQUEST = 'GET_SUMMARY_REQUEST';
export const GET_SUMMARY = 'GET_SUMMARY';
export const GET_TRUCK_LOAD_REQUEST = 'GET_TRUCK_LOAD_REQUEST';
export const GET_TRUCK_LOAD = 'GET_TRUCK_LOAD';
export const GET_BALE_KPI_REQUEST = 'GET_BALE_KPI_REQUEST';
export const GET_BALE_KPI = 'GET_BALE_KPI';
export const GET_DONUT_REQUEST = 'GET_DONUT_REQUEST';
export const GET_DONUT = 'GET_DONUT';
export const GET_GRAPH_REQUEST = 'GET_GRAPH_REQUEST';
export const GET_GRAPH = 'GET_GRAPH';
export const SET_SEARCH_PARAMS = "SET_SEARCH_PARAMS";
export const SET_RETAIN_DATE_TOGGLE = "SET_RETAIN_DATE_TOGGLE";
export const ANALYZE_PARAMS = "ANALYZE_PARAMS";
export const PLAN_ANALYZE_INFO = "PLAN_ANALYZE_INFO";
export const CREW_ANALYZE_INFO = "CREW_ANALYZE_INFO";
export const CUSTOMER_ANALYZE_INFO = "CUSTOMER_ANALYZE_INFO";
export const EG_ANALYZE_INFO = "EG_ANALYZE_INFO";
export const OPERATOR_ANALYZE_INFO = "OPERATOR_ANALYZE_INFO";
export const GET_WORKED_KPI_REQUEST = 'GET_WORKED_KPI_REQUEST';
export const GET_WORKED_KPI = 'GET_WORKED_KPI';
export const CLEAR_ANALYZE_DATA = 'CLEAR_ANALYZE_DATA';
export const REPORT_CONFIG_FETCHING = 'REPORT_CONFIG_FETCHING';
export const GET_REPORT_CONFIG = 'GET_REPORT_CONFIG';
export const GET_REPORT_EG_LIST = 'GET_REPORT_EG_LIST';
export const GET_SPEED_REQUEST = 'GET_SPEED_REQUEST';
export const GET_SPEED = 'GET_SPEED';
export const TRAVEL_KPI = 'TRAVEL_KPI';
export const SET_LOAD_INFO = 'SET_LOAD_INFO';
export const SET_LOAD_INFO_REQUEST = 'SET_LOAD_INFO_REQUEST';
export const TRAVEL_KPI_REQUEST = 'TRAVEL_KPI_REQUEST';
export const ANALYZE_RECENT_SUMMARY = 'ANALYZE_RECENT_SUMMARY';

// MAP
export const MAP_LOADED = "MAP_LOADED";
export const MAP_UNLOAD = "MAP_UNLOAD";
export const MAP_POSITION = "MAP_POSITION";
export const MAP_AUTO_ZOOM = "MAP_AUTO_ZOOM";
export const MAP_EG_REQUESTING = "MAP_EG_REQUESTING";
export const GET_MAP_EG_LIST = "GET_MAP_EG_LIST";
export const FILTER_MAP_EG_LIST = "FILTER_MAP_EG_LIST";
export const CLEAR_MAP_DATA = "CLEAR_MAP_DATA";
export const CLEAR_MAP_FILTERS = "CLEAR_MAP_FILTERS";
export const REFRESH_MAP_DATA = "REFRESH_MAP_DATA";
export const ADD_MAP_EG_KPI_BOX_REQUEST = "ADD_MAP_EG_KPI_BOX_REQUEST";
export const ADD_MAP_EG_KPI_BOX = "ADD_MAP_EG_KPI_BOX";
export const REMOVE_MAP_EG_KPI_BOX = "REMOVE_MAP_EG_KPI_BOX";
export const MAP_EG_CUSTOM_KPI = "MAP_EG_CUSTOM_KPI";
export const GET_MAP_EG_SENSORS = 'GET_MAP_EG_SENSORS';
export const SUBSCRIBE_MAP_EG_KPI = "SUBSCRIBE_MAP_EG_KPI";
export const UNSUBSCRIBE_MAP_EG_KPI = "UNSUBSCRIBE_MAP_EG_KPI";
export const UPDATE_REPLAY_BOX = "UPDATE_REPLAY_BOX";
export const UPDATE_WORK_WINDOW = "UPDATE_WORK_WINDOW";
export const REPLAY_PARAMS = "REPLAY_PARAMS";

// SOCKET
export const CONNECT_SOCKET = "CONNECT_SOCKET";
export const CONNECTED_SOCKET = "CONNECTED_SOCKET";
export const DISCONNECT_SOCKET = "DISCONNECT_SOCKET";
export const ERROR_SOCKET = "ERROR_SOCKET";
export const SUBSCRIBE = "SUBSCRIBE";
export const UNSUBSCRIBE = "UNSUBSCRIBE";
export const MESSAGE_RECEIVED = "MESSAGE_RECEIVED";
export const LIVE_MESSAGE = "LIVE_MESSAGE";
export const SEND_COMMAND = "SEND_COMMAND";
export const UPDATE_LIVE_DATA_SHOW = "UPDATE_LIVE_DATA_SHOW";

// SCALE SOCKET
export const CONNECT_SCALE_SOCKET = "CONNECT_SCALE_SOCKET";
export const CONNECTED_SCALE_SOCKET = "CONNECTED_SCALE_SOCKET";
export const DISCONNECT_SCALE_SOCKET = "DISCONNECT_SCALE_SOCKET";
export const ERROR_SCALE_SOCKET = "ERROR_SCALE_SOCKET";
export const SET_SCALEWEIGHT_INFO = "SET_SCALEWEIGHT_INFO";

// CHAT
export const CONNECT_XMPP = "CONNECT_XMPP";
export const CONNECTED_XMPP = "CONNECTED_XMPP";
export const DISCONNECT_XMPP = "DISCONNECT_XMPP";
export const CHAT_CONTACT_LIST = "CHAT_CONTACT_LIST";
export const SEND_MESSAGE_TO_XMPP = "SEND_MESSAGE_TO_XMPP";
export const RECEIVED_MESSAGE_FROM_XMPP = "MESSAGE_RECEIVED_FROM_XMPP";
export const PUSH_MESSAGE = "PUSH_MESSAGE";
export const PUSH_BULK_MESSAGE = "PUSH_BULK_MESSAGE";
export const START_CONVERSATION = "START_CONVERSATION";
export const GET_USER_LIST = "GET_USER_LIST";
export const GET_UNREAD_MESSAGE_COUNT = "GET_UNREAD_MESSAGE_COUNT";
export const FILE_UPLOADED_ON_SUCCESS = "FILE_UPLOADED_ON_SUCCESS";
export const FILE_UPLOAD_ON_FAILTURE = "FILE_UPLOAD_ON_FAILTURE";
export const FILE_UPLOADING = "FILE_UPLOADING";
export const CHAT_PRESENT = "CHAT_PRESENT";
export const CHAT_EG_LIST = "CHAT_EG_LIST";

// HARDWARE
export const HARDWARE_GET_DEVICE_LIST_REQUEST = 'HARDWARE_GET_DEVICE_LIST_REQUEST';
export const HARDWARE_GET_DEVICE_LIST = 'HARDWARE_GET_DEVICE_LIST';
export const UNASSIGN_CANCODE_SUCCESS = 'UNASSIGN_CANCODE_SUCCESS';
export const GET_DEVICE_COMMAND_LIST_REQUEST = 'GET_DEVICE_COMMAND_LIST_REQUEST';
export const GET_DEVICE_COMMAND_LIST = 'GET_DEVICE_COMMAND_LIST';
export const SEND_DEVICE_COMMAND_REQUEST = 'SEND_DEVICE_COMMAND_REQUEST';
export const SEND_DEVICE_COMMAND_RESPONSE = 'SEND_DEVICE_COMMAND_RESPONSE';
export const CLEAR_SEND_DEVICE_COMMAND = "CLEAR_SEND_DEVICE_COMMAND";
export const GET_LATEST_SENSOR_LIST_REQUEST = 'GET_LATEST_SENSOR_LIST_REQUEST';
export const GET_LATEST_SENSOR_LIST = 'GET_LATEST_SENSOR_LIST';
export const GET_HARDWARE_LIST_REQUEST = 'GET_HARDWARE_LIST_REQUEST';
export const GET_HARDWARE_LIST = "GET_HARDWARE_LIST";
export const UPDATE_HARDWARE_LIST = "UPDATE_HARDWARE_LIST";
export const GET_HARDWARE_ACTIVITY_LIST_REQUEST = 'GET_HARDWARE_ACTIVITY_LIST_REQUEST';
export const GET_HARDWARE_ACTIVITY_LIST = 'GET_HARDWARE_ACTIVITY_LIST';
export const GET_GPS_SENSOR_DATA_REQUEST = "GET_GPS_SENSOR_DATA_REQUEST";
export const GET_GPS_SENSOR_DATA = "GET_GPS_SENSOR_DATA";
export const GET_QAPP_LOGS_REQUEST = "GET_QAPP_LOGS_REQUEST";
export const GET_QAPP_LOGS = "GET_QAPP_LOGS";
export const GET_HARDWARE_TYPE = "GET_HARDWARE_TYPE";
export const GET_HARDWARE_TYPE_REQUEST = "GET_HARDWARE_TYPE_REQUEST";

// GEO REGION
export const SAVE_REGION = 'SAVE_REGION';
export const UPDATE_REGION = "UPDATE_REGION";
export const DELETE_REGION = 'DELETE_REGION';
export const GET_REGIONS_LIST = "GET_REGIONS_LIST";
export const GET_REGIONS_DETAIL = "GET_REGIONS_DETAIL";
export const GET_REGIONS_DETAIL_REQUEST = "GET_REGIONS_DETAIL_REQUEST";
export const GET_REGIONS_TYPE = "GET_REGIONS_TYPE";
export const TOGGLE_WORKWINDOW = "TOGGLE_WORKWINDOW";
export const VISIBLE_WORKWINDOW = "VISIBLE_WORKWINDOW";
export const SELECT_REGIONS = "SELECT_REGIONS";
export const UPDATE_WORK_WINDOW_CONFIG = "UPDATE_WORK_WINDOW_CONFIG";
export const GET_FIELD_WORK_WINDOW_REQUEST = "GET_FIELD_WORK_WINDOW_REQUEST";
export const GET_FIELD_WORK_WINDOW_SUCCESS = "GET_FIELD_WORK_WINDOW_SUCCESS";
export const GET_FIELD_WORK_WINDOW_FAILURE = "GET_FIELD_WORK_WINDOW_SUCCESS";
export const GET_FIELD_WORK_WINDOW_CANCEL = "GET_FIELD_WORK_WINDOW_CANCEL";
export const CLEAR_FIELD_WORK_WINDOWS = "CLEAR_FIELD_WORK_WINDOWS";
export const GET_WORK_WINDOW_CONFIG_REQUEST = "GET_WORK_WINDOW_CONFIG_REQUEST";
export const GET_WORK_WINDOW_CONFIG_SUCCESS = "GET_WORK_WINDOW_CONFIG_SUCCESS";
export const GET_WORK_WINDOW_CONFIG_FAILURE = "GET_WORK_WINDOW_CONFIG_FAILURE";
export const GET_GEO_FIELD_LIST_REQUEST = "GET_GEO_FIELD_LIST_REQUEST";
export const GET_GEO_FIELD_LIST = "GET_GEO_FIELD_LIST";
export const GET_GEO_CROP_LIST = "GET_GEO_CROP_LIST";
export const GET_GEO_WORKED_ACRES_REQUEST = "GET_GEO_WORKED_ACRES_REQUEST";
export const GET_GEO_WORKED_ACRES = "GET_GEO_WORKED_ACRES";
export const FIELD_LIST_REQUEST_ID = "FIELD_LIST_REQUEST_ID";
export const UPDATE_FIELD_WORK_STATUS_SUCCESS = "UPDATE_FIELD_WORK_STATUS_SUCCESS";
export const GEO_REGION_WORKED_DATE = "GEO_REGION_WORKED_DATE";
export const GEO_REGION_WORKED_DATE_REQUEST = "GEO_REGION_WORKED_DATE_REQUEST";
export const GEO_REGION_WORKED_EG = "GEO_REGION_WORKED_EG";
export const GEO_REGION_WORKED_EG_REQUEST = "GEO_REGION_WORKED_EG_REQUEST";
export const TARE_LOAD_CAPACITY = "TARE_LOAD_CAPACITY";
export const GEO_CONFIG = "GEO_CONFIG";
export const GEO_FIELD_REPORT_REQUEST = "GEO_FIELD_REPORT_REQUEST";
export const GEO_FIELD_REPORT = "GEO_FIELD_REPORT";

// DISTANCE
export const GET_DISTANCE_LIST_REQUEST = "GET_DISTANCE_LIST_REQUEST";
export const GET_DISTANCE_LIST = "GET_DISTANCE_LIST";
export const GET_DISTANCE_MATRIX_REQUEST = "GET_DISTANCE_MATRIX_REQUEST";
export const GET_DISTANCE_MATRIX = "GET_DISTANCE_MATRIX";

// GEO STORAGE LOCATION
export const GET_GEO_STORAGE_LOCATION_REQUEST = 'GET_GEO_STORAGE_LOCATION_REQUEST';
export const GET_GEO_STORAGE_LOCATION = 'GET_GEO_STORAGE_LOCATION';
export const GET_GEO_STORAGE_REPORT_REQUEST = 'GET_GEO_STORAGE_REPORT_REQUEST';
export const GET_LOGISTIC_GEO_STORAGE_REPORT_REQUEST = 'GET_LOGISTIC_GEO_STORAGE_REPORT_REQUEST';
export const GET_GEO_STORAGE_REPORT = 'GET_GEO_STORAGE_REPORT';
export const GET_LOGISTIC_GEO_STORAGE_REPORT = 'GET_LOGISTIC_GEO_STORAGE_REPORT';

// CREW KANBAN
export const KANBAN_GET_CREW_LIST_REQUEST = '@crewkanban/GET_CREW_LIST_REQUEST';
export const KANBAN_GET_CREW_LIST = '@crewkanban/GET_CREW_LIST';
export const KANBAN_GET_CREW_INFO_REQUEST = "@crewkanban/GET_CREW_INFO_REQUEST";
export const KANBAN_GET_CREW_INFO = "@crewkanban/GET_CREW_INFO";
export const KANBAN_GET_CREW_INFO_ASSIGN = "@crewkanban/GET_CREW_INFO_ASSIGN";
export const APPLY_FILTERS = '@crewkanban/APPLY_FILTERS';
export const CREW_SELECTION = '@crewkanban/CREW_SELECTION';
export const MOVE_COLUMN = '@crewkanban/MOVE_COLUMN';
export const MOVE_CARD = '@crewkanban/MOVE_CARD';
export const UPDATE_CREW_INFO = '@crewkanban/UPDATE_CREW_INFO';
export const CREW_SAVE_REQUEST = '@crewkanban/CREW_SAVE_REQUEST';
export const CLEAR_CREW_KANBAN = '@crewkanban/CLEAR_CREW_KANBAN';
export const CREATE_CREW = '@crewkanban/CREATE_CREW';
export const CREW_SAVE_SUCCESS = '@crewkanban/CREW_SAVE_SUCCESS';
export const CREW_ASSIGN_SAVE = '@crewkanban/CREW_ASSIGN_SAVE';
export const REMOVE_ASSIGN_CREW = '@crewkanban/REMOVE_ASSIGN_CREW';
export const SET_CREW_SEARCH_TEXT = '@crewkanban/SET_CREW_SEARCH_TEXT';
export const SET_CREW_FILTERED_LIST = '@crewkanban/SET_CREW_FILTERED_LIST';
export const CREW_SAVE_FAILURE = '@crewkanban/CREW_SAVE_FAILURE';
export const RESET_CREW = '@crewkanban/RESET_CREW';
export const ASSIGNED_EG = '@crewkanban/ASSIGNED_EG';
export const CREW_GET_GEO_REGION_REQUEST = '@crewkanban/GET_GEO_REGION_REQUEST';
export const CREW_GET_GEO_REGION = '@crewkanban/GET_GEO_REGION';

//EG KANBAN
export const EG_SELECTION = "EG_SELECTION";
export const HANDLE_EG_DRAG_DROP = "HANDLE_EG_DRAG_DROP";
export const GET_OPTION_LIST_REQUEST = "GET_OPTION_LIST_REQUEST";
export const GET_OPTION_LIST = "GET_OPTION_LIST";
export const SET_FILTER_LIST = "SET_FILTER_LIST";
export const APPLY_EG_FILTERS = "APPLY_EG_FILTERS";
export const RESET_EG = "RESET_EG";
export const UPDATE_EG_INFO = "UPDATE_EG_INFO";
export const CREATE_EG = "CREATE_EG";
export const EG_SAVE_REQUEST = "EG_SAVE_REQUEST";
export const EG_SAVE_SUCCESS = "EG_SAVE_SUCCESS";
export const EG_SAVE_FAILURE = "EG_SAVE_FAILURE";
export const CLEAR_EG_KANBAN = "CLEAR_EG_KANBAN";
export const VALIDATE_EG = "VALIDATE_EG";

//DASHBOARD/COMMON
export const DASHBOARD_SET_FARM_ID = "DASHBOARD_SET_FARM_ID";
export const DASHBOARD_GET_PLAN_TYPE_LIST = "DASHBOARD_GET_PLAN_TYPE_LIST";
export const DASHBOARD_SET_ACTIVE_TAB = "DASHBOARD_SET_ACTIVE_TAB";
export const DASHBOARD_GET_PLANNED_DATE_REQUEST = "DASHBOARD_GET_PLANNED_DATE_REQUEST";
export const DASHBOARD_GET_PLANNED_DATE = "DASHBOARD_GET_PLANNED_DATE";
export const DASHBOARD_ADD_REQUEST_ID = "DASHBOARD_ADD_REQUEST_ID";
export const DASHBOARD_CLEAR_REQUEST_IDS = "DASHBOARD_CLEAR_REQUEST_IDS";
export const DASHBOARD_REFRESH = "DASHBOARD_REFRESH";
export const DASHBOARD_CLEAR = "DASHBOARD_CLEAR";
export const UPDATE_DASHBOARD_FIELD_WORK_STATUS_SUCCESS = "UPDATE_DASHBOARD_FIELD_WORK_STATUS_SUCCESS";
export const DASHBOARD_USER_REMEMBER = "DASHBOARD_USER_REMEMBER";
export const DASHBOARD_USER_REMEMBER_REQUEST = "DASHBOARD_USER_REMEMBER_REQUEST";

//DASHBOARD/LEADER BOARD
export const DASHBOARD_SET_COLLAPSE_LEADER_BOARD = "DASHBOARD_SET_COLLAPSE_LEADER_BOARD";
export const DASHBOARD_SET_SELECTED_WORK_TYPE_LEADERBOARD = "DASHBOARD_SET_SELECTED_WORK_TYPE_LEADERBOARD";
export const DASHBOARD_GET_EG_LIST_REQUEST = "DASHBOARD_GET_EG_LIST_REQUEST";
export const DASHBOARD_GET_EG_LIST = "DASHBOARD_GET_EG_LIST";
export const DASHBOARD_GET_MANUAL_LOAD_REQUEST_FOR_LEADERBOARD = "DASHBOARD_GET_MANUAL_LOAD_REQUEST_FOR_LEADERBOARD";
export const DASHBOARD_GET_MANUAL_LOAD_FOR_LEADERBOARD = "DASHBOARD_GET_MANUAL_LOAD_FOR_LEADERBOARD";
export const DASHBOARD_GET_AUTOMATIC_EG_LOAD_REQUEST = "DASHBOARD_GET_AUTOMATIC_EG_LOAD_REQUEST";
export const DASHBOARD_GET_AUTOMATIC_EG_LOAD = "DASHBOARD_GET_AUTOMATIC_EG_LOAD";
export const DASHBOARD_GET_SOURCE_EG_ELASTIC_DATA_REQUEST = "DASHBOARD_GET_SOURCE_EG_ELASTIC_DATA_REQUEST";
export const DASHBOARD_GET_SOURCE_EG_ELASTIC_DATA = "DASHBOARD_GET_SOURCE_EG_ELASTIC_DATA";
export const DASHBOARD_GET_EG_SPEED_REQUEST = 'GET_EG_SPEED_REQUEST';
export const DASHBOARD_GET_EG_SPEED = 'GET_EG_SPEED';

//DASHBOARD/CREWS
export const DASHBOARD_SET_SELECTED_PLAN_TYPE_FOR_CREW = "DASHBOARD_SET_SELECTED_PLAN_TYPE_FOR_CREW";
export const DASHBOARD_SET_SELECTED_CREWS = "DASHBOARD_SET_SELECTED_CREWS";
export const DASHBOARD_INCLUDE_ENDED_CREW = "DASHBOARD_INCLUDE_ENDED_CREW";
export const DASHBOARD_GET_CREW_LIST_REQUEST = "DASHBOARD_GET_CREW_LIST_REQUEST";
export const DASHBOARD_GET_CREW_LIST = "DASHBOARD_GET_CREW_LIST";
export const DASHBOARD_GET_CREW_SUMMARY_REQUEST = "DASHBOARD_GET_CREW_SUMMARY_REQUEST";
export const DASHBOARD_GET_CREW_SUMMARY = "DASHBOARD_GET_CREW_SUMMARY";
export const DASHBOARD_GET_CREW_DONUT_REQUEST = "DASHBOARD_GET_CREW_DONUT_REQUEST";
export const DASHBOARD_GET_CREW_DONUT = "DASHBOARD_GET_CREW_DONUT";
export const DASHBOARD_GET_CREW_GRAPH_REQUEST = "DASHBOARD_GET_CREW_GRAPH_REQUEST";
export const DASHBOARD_GET_CREW_GRAPH = "DASHBOARD_GET_CREW_GRAPH";
export const DASHBOARD_GET_CREW_ELASTIC_DATA_REQUEST = "DASHBOARD_GET_CREW_ELASTIC_DATA_REQUEST";
export const DASHBOARD_GET_CREW_ELASTIC_DATA = "DASHBOARD_GET_CREW_ELASTIC_DATA";

//DASHBOARD/FIELDS
export const DASHBOARD_SET_SELECTED_WORK_TYPE_FOR_FIELD = "DASHBOARD_SET_SELECTED_WORK_TYPE_FOR_FIELD";
export const DASHBOARD_SET_SELECTED_FIELDS = "DASHBOARD_SET_SELECTED_FIELDS";
export const DASHBOARD_SET_FILTERED_FIELDS = "DASHBOARD_SET_FILTERED_FIELDS";
export const DASHBOARD_SET_SORT_BY = "DASHBOARD_SET_SORT_BY";
export const DASHBOARD_GET_EG_LIST_REQUEST_FOR_FIELD = "DASHBOARD_GET_EG_LIST_REQUEST_FOR_FIELD";
export const DASHBOARD_GET_EG_LIST_FOR_FIELD = "DASHBOARD_GET_EG_LIST_FOR_FIELD";
export const DASHBOARD_GET_REGION_LIST_REQUEST = "DASHBOARD_GET_REGION_LIST_REQUEST";
export const DASHBOARD_GET_REGION_LIST = "DASHBOARD_GET_REGION_LIST";
export const DASHBOARD_GET_WORKED_ACRES_REQUEST = "DASHBOARD_GET_WORKED_ACRES_REQUEST";
export const DASHBOARD_GET_WORKED_ACRES = "DASHBOARD_GET_WORKED_ACRES";
export const DASHBOARD_GET_EG_WORED_ACRES_REQUEST = "DASHBOARD_GET_EG_WORED_ACRES_REQUEST";
export const DASHBOARD_GET_EG_WORED_ACRES = "DASHBOARD_GET_EG_WORED_ACRES";
export const DASHBOARD_GET_FIELD_LOADS_REQUEST = "DASHBOARD_GET_FIELD_LOADS_REQUEST";
export const DASHBOARD_GET_FIELD_LOADS = "DASHBOARD_GET_FIELD_LOADS";
export const DASHBOARD_GET_FIELD_LOADS_TODATE_REQUEST = "DASHBOARD_GET_FIELD_LOADS_TODATE_REQUEST";
export const DASHBOARD_GET_FIELD_LOADS_TODATE = "DASHBOARD_GET_FIELD_LOADS_TODATE";
export const DASHBOARD_GET_TARE_LOADS_REQUEST = "DASHBOARD_GET_TARE_LOADS_REQUEST";
export const DASHBOARD_GET_TARE_LOADS = "DASHBOARD_GET_TARE_LOADS";

//DASHBOARD/OFFLOAD
export const DASHBOARD_SET_OFFLOAD_REQUEST = "DASHBOARD_SET_OFFLOAD_REQUEST";
export const DASHBOARD_SET_OFFLOAD_LIST = "DASHBOARD_SET_OFFLOAD_LIST";
export const DASHBOARD_SET_OFFLOAD_REPORT_REQUEST = "DASHBOARD_SET_OFFLOAD_REPORT_REQUEST";
export const DASHBOARD_SET_OFFLOAD_REPORT = "DASHBOARD_SET_OFFLOAD_REPORT";
export const DASHBOARD_SET_OFFLOAD_DETAILS = "DASHBOARD_SET_OFFLOAD_DETAILS";
export const DASHBOARD_SET_OFFLOAD_DETAILS_REQUEST = "DASHBOARD_SET_OFFLOAD_DETAILS_REQUEST";


//DASHBOARD/LOADS
export const DASHBOARD_SET_CHART_VIEW_TYPE = "DASHBOARD_SET_CHART_VIEW_TYPE";
export const DASHBOARD_SET_SELECTED_LOAD_MAIN_VIEW = "DASHBOARD_SET_SELECTED_LOAD_MAIN_VIEW";
export const DASHBOARD_SET_SELECTED_LOAD_SUB_VIEW = "DASHBOARD_SET_SELECTED_LOAD_SUB_VIEW";
export const DASHBOARD_GET_MANUAL_LOAD_REQUEST = "DASHBOARD_GET_MANUAL_LOAD_REQUEST";
export const DASHBOARD_GET_MANUAL_LOAD = "DASHBOARD_GET_MANUAL_LOAD";
export const DASHBOARD_GET_HARVEST_SUMMARY = "DASHBOARD_GET_HARVEST_SUMMARY";
export const DASHBOARD_GET_HARVEST_SUMMARY_REQUEST = "DASHBOARD_GET_HARVEST_SUMMARY_REQUEST";

//LOAD
export const SET_LOAD_HISTORY_SHOW_MODAL = "SET_LOAD_HISTORY_SHOW_MODAL";
export const SET_LOAD_HISTORY_PARAMS = "SET_LOAD_HISTORY_PARAMS";
export const SET_LOAD_QUEUE_TYPE = "SET_LOAD_QUEUE_TYPE";
export const LOAD_QUEUE_LIST_REQUEST = "LOAD_QUEUE_LIST_REQUEST";
export const LOAD_QUEUE_LIST = "LOAD_QUEUE_LIST";
export const LOAD_QUEUE_CUSTOMER_LIST_REQUEST = "LOAD_QUEUE_CUSTOMER_LIST_REQUEST";
export const LOAD_QUEUE_CUSTOMER_LIST = "LOAD_QUEUE_CUSTOMER_LIST";
export const LOAD_QUEUE_COUNT = "LOAD_QUEUE_COUNT";
export const LOAD_QUEUE_APPROVED = "LOAD_QUEUE_APPROVED";
export const LOAD_QUEUE_APPROVAL_CANCELLED = "LOAD_QUEUE_APPROVAL_CANCELLED";
export const UNLOAD_SITE_QUEUE_LIST = "UNLOAD_SITE_QUEUE_LIST";
export const LOAD_TRIP_LIST_REQUEST = "LOAD_TRIP_LIST_REQUEST";
export const LOAD_TRIP_LIST = "LOAD_TRIP_LIST";
export const SET_SELECTED_LOAD_IDS = "SET_SELECTED_LOAD_IDS";
export const SET_LOAD_QUEUE_INPUTS = "SET_LOAD_QUEUE_INPUTS";
export const PICKED_LIST = 'PICKED_LIST';
export const PICKED_LIST_REQUEST = 'PICKED_LIST_REQUEST';
export const TOTAL_LOAD_TRIP_COUNT_REQUEST = 'TOTAL_LOAD_TRIP_COUNT_REQUEST';
export const TOTAL_LOAD_TRIP_COUNT = 'TOTAL_LOAD_TRIP_COUNT';
export const SET_LOAD_QUEUE_SEARCH_TEXT = 'SET_LOAD_QUEUE_SEARCH_TEXT';
export const SET_LOAD_QUEUE_SORT_ORDER = 'SET_LOAD_QUEUE_SORT_ORDER';
export const SET_LOAD_QUEUE_FILTER_IDS = 'SET_LOAD_QUEUE_FILTER_IDS';
export const SET_LOAD_QUEUE_FILTERS = 'SET_LOAD_QUEUE_FILTERS';
export const SET_LOAD_TIMELINE = 'SET_LOAD_TIMELINE';
export const SET_LOAD_TIMELINE_REQUEST = 'SET_LOAD_TIMELINE_REQUEST';
export const SET_TARE_LOAD_REQUESTING = 'SET_TARE_LOAD_REQUESTING';
export const SET_TARE_LOAD = 'SET_TARE_LOAD';
export const UPDATE_TARE_LOAD = 'UPDATE_TARE_LOAD';
export const UPDATE_LOAD_LIST = 'UPDATE_LOAD_LIST';
export const REMOVE_LOAD_QUEUE_DATA = 'REMOVE_LOAD_QUEUE_DATA';
export const GET_LOAD_REGION_LIST = 'GET_LOAD_REGION_LIST';
export const GET_LOAD_REGION_LIST_REQUESTING = 'GET_LOAD_REGION_LIST_REQUESTING';
export const GET_LOAD_SOURCE_EG_LIST = 'GET_LOAD_SOURCE_EG_LIST';
export const GET_LOAD_SOURCE_EG_LIST_REQUESTING = 'GET_LOAD_SOURCE_EG_LIST_REQUESTING';
export const SET_PLANTING_QUEUE_INPUTS = "SET_PLANTING_QUEUE_INPUTS";

//FARM MONITOR/COMMON
export const FARM_MONITOR_SET_FARM_ID = "FARM_MONITOR_SET_FARM_ID";
export const FARM_MONITOR_SET_PLAN_TYPE_ID = "FARM_MONITOR_SET_PLAN_TYPE_ID";
export const FARM_MONITOR_ADD_REQUEST_ID = "FARM_MONITOR_ADD_REQUEST_ID";
export const FARM_MONITOR_CLEAR_REQUEST_IDS = "FARM_MONITOR_CLEAR_REQUEST_IDS";
export const CLEAR_FARM_MONITOR = "CLEAR_FARM_MONITOR";
export const FARM_MONITOR_REFRESH = "FARM_MONITOR_REFRESH";

//FARM MONITOR/WORKED DETAILS
export const FARM_MONITOR_GET_SUMMARY_REQUEST = "FARM_MONITOR_GET_SUMMARY_REQUEST";
export const FARM_MONITOR_GET_SUMMARY = "FARM_MONITOR_GET_SUMMARY";
export const FARM_MONITOR_GET_GRAPH_REQUEST = "FARM_MONITOR_GET_GRAPH_REQUEST";
export const FARM_MONITOR_GET_GRAPH = "FARM_MONITOR_GET_GRAPH";
export const FARM_MONITOR_LOADS_SUMMARY_REQUEST = "FARM_MONITOR_LOADS_SUMMARY_REQUEST";
export const FARM_MONITOR_LOADS_SUMMARY = "FARM_MONITOR_LOADS_SUMMARY";
export const FARM_MONITOR_GET_WORKED_KPI_REQUEST = "FARM_MONITOR_GET_WORKED_KPI_REQUEST";
export const FARM_MONITOR_GET_WORKED_KPI = "FARM_MONITOR_GET_WORKED_KPI";
export const FARM_MONITOR_SUBSCRIBE_FARM_ANALYSE_KPI = "FARM_MONITOR_SUBSCRIBE_FARM_ANALYSE_KPI";
export const FARM_MONITOR_UNSUBSCRIBE_FARM_ANALYSE_KPI = "FARM_MONITOR_UNSUBSCRIBE_FARM_ANALYSE_KPI";

//FARM MONITOR/WORKED FIELD DETAILS
export const FARM_MONITOR_GET_REGION_LIST_REQUEST = "FARM_MONITOR_GET_REGION_LIST_REQUEST";
export const FARM_MONITOR_GET_REGION_LIST = "FARM_MONITOR_GET_REGION_LIST";
export const FARM_MONITOR_GET_EG_LIST_REQUEST_FOR_FIELD = "FARM_MONITOR_GET_EG_LIST_REQUEST_FOR_FIELD";
export const FARM_MONITOR_GET_EG_LIST_FOR_FIELD = "FARM_MONITOR_GET_EG_LIST_FOR_FIELD";
export const FARM_MONITOR_GET_WORKED_ACRES_REQUEST = "FARM_MONITOR_GET_WORKED_ACRES_REQUEST";
export const FARM_MONITOR_GET_WORKED_ACRES = "FARM_MONITOR_GET_WORKED_ACRES";
export const FARM_MONITOR_GET_EG_WORED_ACRES_REQUEST = "FARM_MONITOR_GET_EG_WORED_ACRES_REQUEST";
export const FARM_MONITOR_GET_EG_WORED_ACRES = "FARM_MONITOR_GET_EG_WORED_ACRES";
export const FARM_MONITOR_GET_FIELD_LOADS_REQUEST = "FARM_MONITOR_GET_FIELD_LOADS_REQUEST";
export const FARM_MONITOR_GET_FIELD_LOADS = "FARM_MONITOR_GET_FIELD_LOADS";

//FARM MONITOR/Q APP
export const FARM_MONITOR_GET_DEVICE_LIST_REQUEST = "FARM_MONITOR_GET_DEVICE_LIST_REQUEST";
export const FARM_MONITOR_GET_DEVICE_LIST = "FARM_MONITOR_GET_DEVICE_LIST";
export const FARM_MONITOR_GET_DEVICE_SENSORS_REQUEST = "FARM_MONITOR_GET_DEVICE_SENSORS_REQUEST";
export const FARM_MONITOR_GET_DEVICE_SENSORS = "FARM_MONITOR_GET_DEVICE_SENSORS";
export const FARM_MONITOR_SUBSCRIBE_EG_DEVICE_KPI = "FARM_MONITOR_SUBSCRIBE_EG_DEVICE_KPI";
export const FARM_MONITOR_UNSUBSCRIBE_EG_DEVICE_KPI = "FARM_MONITOR_UNSUBSCRIBE_EG_DEVICE_KPI";
export const FARM_MONITOR_EG_DEVICE_KPI_LIVE_MESSAGE = "FARM_MONITOR_EG_DEVICE_KPI_LIVE_MESSAGE";
export const FARM_MONITOR_SET_SUMMARY_TOGGLE_COLLAPSE = "FARM_MONITOR_SET_SUMMARY_TOGGLE_COLLAPSE";
export const FARM_MONITOR_SET_WORKED_ACRES_RANGE_TYPE = "FARM_MONITOR_SET_WORKED_ACRES_RANGE_TYPE";

//USER MANAGEMENT
export const USER_GET_ROLE_LIST_REQUEST = "USER_GET_ROLE_LIST_REQUEST";
export const USER_GET_ROLE_LIST = "USER_ROLE_LIST";
export const USER_LIST_REQUEST = "USER_LIST_REQUEST";
export const USER_GET_USER_LIST = "USER_GET_USER_LIST";
export const USER_GET_FARM_LIST_REQUEST = "USER_GET_FARM_LIST_REQUEST";
export const USER_GET_FARM_LIST = 'USER_GET_FARM_LIST';
export const USER_GET_USER_FARM_LIST_REQUEST = "USER_GET_USER_FARM_LIST_REQUEST";
export const USER_GET_USER_FARM_LIST = 'USER_GET_USER_FARM_LIST';
export const USER_GET_AUTH_PROVIDER_LIST_REQUEST = "USER_GET_AUTH_PROVIDER_LIST_REQUEST";
export const USER_GET_AUTH_PROVIDER_LIST = "USER_GET_AUTH_PROVIDER_LIST";
export const USER_GET_AUTH_LIST_REQUEST = "USER_GET_AUTH_LIST_REQUEST";
export const USER_GET_AUTH_LIST = "USER_GET_AUTH_LIST";
export const USER_GET_ROLE_PERMISSION_LIST_REQUEST = "USER_GET_ROLE_PERMISSION_LIST_REQUEST";
export const USER_GET_ROLE_PERMISSION_LIST = "USER_GET_ROLE_PERMISSION_LIST";
export const USER_GET_CONTROLLER_LIST_REQUEST = "USER_GET_CONTROLLER_LIST_REQUEST";
export const USER_GET_CONTROLLER_LIST = "USER_GET_CONTROLLER_LIST";
export const USER_UPDATE_ROLE_PERMISSION = "USER_UPDATE_ROLE_PERMISSION";
export const USER_GET_USER_PERMISSION_REQUEST = "USER_GET_USER_PERMISSION_REQUEST";
export const USER_GET_USER_PERMISSION = "USER_GET_USER_PERMISSION";
export const USER_UPDATE_USER_PERMISSION = "USER_UPDATE_USER_PERMISSION";
export const SET_QR_SECERET_KEYS = "SET_QR_SECERET_KEYS";

//BOARD
export const GET_BOARD_LIST_REQUEST = "GET_BOARD_LIST_REQUEST";
export const GET_BOARD_LIST = 'GET_BOARD_LIST';

//Message Policy
export const GET_POLICY_REQUEST = 'GET_POLICY_REQUEST';
export const GET_POLICY_LIST = 'GET_POLICY_LIST';
export const ADD_POLICY = 'ADD_POLICY';
export const EDIT_POLICY = 'EDIT_POLICY';
export const DELETE_POLICY = 'DELETE_POLICY';

//Plan
export const SET_SELECTED_PLAN = 'SET_SELECTED_PLAN';
export const SET_ALL_PLAN = 'SET_ALL_PLAN';
export const SET_SEED_HISTORY = 'SET_SEED_HISTORY';
export const SET_SEED_REQUESTING = 'SET_SEED_REQUESTING';
export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';
export const SET_SEED_DETAIL = 'SET_SEED_DETAIL';
export const SET_SELECTED_IDS = 'SET_SELECTED_IDS';
export const SET_FILTERED_SEED_HISTORY = 'SET_FILTERED_SEED_HISTORY';
export const SET_SEED_VARIETY_DETAILS = 'SET_SEED_VARIETY_DETAILS';
export const SET_SEED_LOT_DETAILS = 'SET_SEED_LOT_DETAILS';
export const SET_SEED_SUPPLIER_DETAILS = 'SET_SEED_SUPPLIER_DETAILS';
export const SET_SEED_TYPE_DETAILS = 'SET_SEED_TYPE_DETAILS';
export const SET_SEED_CUTTING_GROUP = 'SET_SEED_CUTTING_GROUP';
export const REMOVE_SEED_LOADS = 'REMOVE_SEED_LOADS';
export const UPDATE_SEED_LOAD = 'UPDATE_SEED_LOAD';
export const SET_BULK_EDIT = 'SET_BULK_EDIT';
export const SET_EDITED_SEED_HISTORY = 'SET_EDITED_SEED_HISTORY';
export const SET_SELECTED_SEED_LOAD_ID = 'SET_SELECTED_SEED_LOAD_ID';
export const SET_SEED_DISCARD = 'SET_SEED_DISCARD';
export const UPDATE_PAYLOAD = 'UPDATE_PAYLOAD';
export const SET_SEED_TIMELINE = 'SET_SEED_TIMELINE';
export const SET_SEED_TIMELINE_REQUESTING = 'SET_SEED_TIMELINE_REQUESTING';
export const GET_EG_OPERATOR = 'GET_EG_OPERATOR';
export const GET_FARM_USERS = 'GET_FARM_USERS';
export const GET_INCIDENT_TYPE = 'GET_INCIDENT_TYPE';
export const SET_SEED_TARE_LOAD_REQUESTING = 'SET_SEED_TARE_LOAD_REQUESTING';
export const SET_SEED_TARE_LOAD = 'SET_SEED_TARE_LOAD';
export const UPDATE_SEED_TARE_LOAD = 'UPDATE_SEED_TARE_LOAD'
export const SET_ISCOMPLETE = 'SET_ISCOMPLETE';
export const SET_IS_NEED_PLANTER_VALUES = 'SET_IS_NEED_PLANTER_VALUES';
export const SET_LOAD_HISTORY_RELOAD = 'SET_LOAD_HISTORY_RELOAD';

//Logistics
export const SET_SELECTED_LOGISTICS_PLAN = 'SET_SELECTED_LOGISTICS_PLAN';
export const SET_ALL_LOGISTICS_PLAN = 'SET_ALL_LOGISTICS_PLAN';
export const SET_LOGISTICS_HISTORY = 'SET_LOGISTICS_HISTORY';
export const SET_LOGISTICS_REQUESTING = 'SET_LOGISTICS_REQUESTING';
export const SET_LOGISTICS_SEARCH_TEXT = 'SET_LOGISTICS_SEARCH_TEXT';
export const SET_LOGISTICS_DETAIL = 'SET_LOGISTICS_DETAIL';
export const SET_LOGISTICS_SELECTED_IDS = 'SET_LOGISTICS_SELECTED_IDS';
export const SET_FILTERED_LOGISTICS_HISTORY = 'SET_FILTERED_LOGISTICS_HISTORY';
export const SET_LOGISTIC_VARIETY_DETAILS = 'SET_LOGISTIC_VARIETY_DETAILS';
export const SET_LOGISTIC_LOT_DETAILS = 'SET_LOGISTIC_LOT_DETAILS';
export const SET_LOGISTIC_SUPPLIER_DETAILS = 'SET_LOGISTIC_SUPPLIER_DETAILS';
export const SET_LOGISTICS_SEED_TYPE_DETAILS = 'SET_LOGISTICS_SEED_TYPE_DETAILS';
export const SET_LOGISTICS_SEED_CUTTING_GROUP = 'SET_LOGISTICS_SEED_CUTTING_GROUP';
export const REMOVE_LOGISTIC_LOADS = 'REMOVE_LOGISTIC_LOADS';
export const UPDATE_LOGISTIC_LOAD = 'UPDATE_LOGISTIC_LOAD';
export const SET_LOGISTIC_BULK_EDIT = 'SET_LOGISTIC_BULK_EDIT';
export const SET_EDITED_LOGISTIC_HISTORY = 'SET_EDITED_LOGISTIC_HISTORY';
export const SET_SELECTED_LOGISTIC_LOAD_ID = 'SET_SELECTED_LOGISTIC_LOAD_ID';
export const SET_LOGISTIC_DISCARD = 'SET_LOGISTIC_DISCARD';
export const UPDATE_LOGISTIC_PAYLOAD = 'UPDATE_LOGISTIC_PAYLOAD';
export const SET_LOGISTIC_TIMELINE = 'SET_LOGISTIC_TIMELINE';
export const SET_LOGISTIC_TIMELINE_REQUESTING = 'SET_LOGISTIC_TIMELINE_REQUESTING';
export const GET_LOGISTICS_EG_OPERATOR = 'GET_LOGISTICS_EG_OPERATOR';
export const GET_LOGISTICS_FARM_USERS = 'GET_LOGISTICS_FARM_USERS';
export const GET_LOGISTICS_INCIDENT_TYPE = 'GET_LOGISTICS_INCIDENT_TYPE';
export const SET_LOGISTICS_TARE_HISTORY = 'SET_LOGISTICS_TARE_HISTORY';
export const SET_LOGISTICS_TARE_REQUESTING = 'SET_LOGISTICS_TARE_REQUESTING';
export const UPDATE_LOGISTICS_TARE_LOAD = 'UPDATE_LOGISTICS_TARE_LOAD'

// OEM
export const OEM_MAKE_LIST = 'OEM_MAKE_LIST';
export const OEM_MAKE_LIST_REQUESTING = 'OEM_MAKE_LIST_REQUESTING';
export const USER_OEM_LIST = 'USER_OEM_LIST';
export const USER_OEM_LIST_REQUESTING = 'USER_OEM_LIST_REQUESTING';
export const OEM_UNKNOWN_DEVICE = 'OEM_UNKNOWN_DEVICE';
export const OEM_UNKNOWN_DEVICE_REQUESTING = 'OEM_UNKNOWN_DEVICE_REQUESTING';

// Customer
export const FARM_CUSTOMER_LIST = 'FARM_CUSTOMER_LIST'
export const FARM_CUSTOMER_LIST_REQUESTING = 'FARM_CUSTOMER_LIST_REQUESTING'
export const USER_CUSTOMER_LIST = 'USER_CUSTOMER_LIST'
export const USER_CUSTOMER_LIST_REQUESTING = 'USER_CUSTOMER_LIST_REQUESTING'

// AI Chatbot
export const SET_AI_CHAT_BOT = 'SET_AI_CHAT_BOT';
export const SET_AI_CHAT_MESSAGE = 'SET_AI_CHAT_MESSAGE';
export const SET_AI_CHAT_BOT_ID = 'SET_AI_CHAT_BOT_ID';

// Network Type
export const NETWORK_TYPE_LIST = 'NETWORK_TYPE_LIST';
export const GET_NETWORK_LIST_REQUEST = 'GET_NETWORK_LIST_REQUEST';
export const NETWORK_LIST = 'NETWORK_LIST';

//SCOUT OBSERVATION
export const GET_SCOUT_OBSERVATION_LIST_REQUEST = 'GET_SCOUT_OBSERVATION_LIST_REQUEST';
export const GET_SCOUT_OBSERVATION_LIST = "GET_SCOUT_OBSERVATION_LIST";
export const GET_SCOUT_OBSERVATION_CONFIG_REQUEST = "GET_SCOUT_OBSERVATION_CONFIG_REQUEST";
export const GET_SCOUT_OBSERVATION_CONFIG = "GET_SCOUT_OBSERVATION_CONFIG";
export const SET_SCOUT_ACTIVE_TAB = 'SET_SCOUT_ACTIVE_TAB';

//Scout-Group
export const MOVE_SCOUT_GROUP_COLUMN = 'MOVE_SCOUT_GROUP_COLUMN';
export const MOVE_SCOUT_MEMBER_CARD = 'MOVE_SCOUT_MEMBER_CARD';
export const KANBAN_GET_SCOUT_GROUP_LIST_REQUEST = 'KANBAN_GET_SCOUT_GROUP_LIST_REQUEST';
export const KANBAN_GET_SCOUT_GROUP_LIST = 'KANBAN_GET_SCOUT_GROUP_LIST';
export const SCOUT_GROUP_SAVE_REQUEST = 'SCOUT_GROUP_SAVE_REQUEST';
export const SCOUT_GROUP_SAVE_SUCCESS = 'SCOUT_GROUP_SAVE_SUCCESS';
export const SCOUT_GROUP_SAVE_FAILURE = 'SCOUT_GROUP_SAVE_FAILURE';
export const SCOUT_GET_GEO_REGION_REQUEST = 'SCOUT_GET_GEO_REGION_REQUEST';
export const SCOUT_GET_GEO_REGION = 'SCOUT_GET_GEO_REGION';
export const SCOUT_GET_FARM_USERS_LIST_REQUEST = 'SCOUT_GET_FARM_USERS_LIST_REQUEST';
export const SCOUT_GET_FARM_USERS_LIST = 'SCOUT_GET_FARM_USERS_LIST';
export const ADD_SCOUT_GROUP = 'ADD_SCOUT_GROUP';
export const REMOVE_SCOUT_MEMBER = 'REMOVE_SCOUT_MEMBER';
export const REMOVE_SCOUT_GROUP = 'REMOVE_SCOUT_GROUP';
export const EDIT_SCOUT_GROUP = 'EDIT_SCOUT_GROUP';
export const SET_SCOUT_SEARCH_TEXT = 'SET_SCOUT_SEARCH_TEXT';
export const SCOUT_GROUP_SELECTION = 'SCOUT_GROUP_SELECTION';
export const RESET_SCOUT_GROUP = 'RESET_SCOUT_GROUP';


//SCALE REMOTE
export const GET_SCALE_REMOTE_REQUEST = 'GET_SCALE_REMOTE_REQUEST';
export const SET_SCALE_REMOTE = 'SET_SCALE_REMOTE';

// RATE SCHEDULE
export const GET_RATE_TYPE_LISTS = 'GET_RATE_TYPE_LISTS';
export const GET_RATE_TYPE_LISTS_REQUEST = 'GET_RATE_TYPE_LISTS_REQUEST';
export const GET_RATE_SCHEDULE_LISTS = 'GET_RATE_SCHEDULE_LISTS';
export const GET_RATE_SCHEDULE_LISTS_REQUEST = 'GET_RATE_SCHEDULE_LISTS_REQUEST';

//SCALE DEVICE
export const GET_SCALE_DEVICE_LIST_REQUEST = 'GET_SCALE_DEVICE_LIST_REQUEST';
export const GET_SCALE_DEVICE_LIST = 'GET_SCALE_DEVICE_LIST';
export const  SAVE_SCALE_DEVICE_REQUEST = 'SAVE_SCALE_DEVICE_REQUEST';
export const  SAVE_SCALE_DEVICE_SUCCESS = 'SAVE_SCALE_DEVICE_SUCCESS';
export const  DELETE_SCALE_DEVICE_REQUEST = 'DELETE_SCALE_DEVICE_REQUEST';
export const  DELETE_SCALE_DEVICE_SUCCESS = 'DELETE_SCALE_DEVICE_SUCCESS';
export const  UPDATE_SCALE_DEVICE_REQUEST = 'UPDATE_SCALE_DEVICE_REQUEST';
export const  UPDATE_SCALE_DEVICE_SUCCESS = 'UPDATE_SCALE_DEVICE_SUCCESS';


